import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    ScreenerToken: '',
    MainModule: 'filter',
    FilterSelection: {
        "indcodes": "",
        "sectcodes": "",
        "absnames": "",
        "segnames": "",
        "nic_year1": "2008",
        "niccodes1": "",
        "nic_year2": "2008",
        "niccodes2": "",
        "finprodcodes1": "",
        "finprod_persale1": "",
        "finprod_saleval1": "",
        "finprodcodes2": "",
        "finprod_persale2": "",
        "finprod_saleval2": "",
        "finprod_year1": "",
        "finprod_year2": ""
    },
    CriteriaBuilderFilter: [],
    // ============= NEW STATE FOR PERSISTENCE =============
    // CriteriaRows: [],           // Store all criteria rows
    CompanyCodes: '',           // Store company codes
    TotalMatchedCompanies: 0,   // Store total matched companies
    YearEnd: 'LATEST',          // Store year end
    NoOfYears: '1',         // Store number of years
    handleDefaultFeilds: true,

    SelectedModule: 'Background',      // Selected radio button (Background, Balance Sheet, etc.)
    SelectedDFMT: 'MAN',                   // Selected Format type
    SelectedScreenID: 'BACKGROUND',     // Selected Screen ID
    // SelectedColumns: []                 // Selected columns from "Select Columns"
}

export const TpscreenerLocalSlice = createSlice({
    name: "tpscreener",
    initialState,
    reducers: {
        SetTPScreenerToken: (state, action) => {
            state.ScreenerToken = action.payload
        },
        SetMainModule: (state, action) => {
            state.MainModule = action.payload
        },
        SetFilterSelection: (state, action) => {
            state.FilterSelection = action.payload
        },
        SetCriteriaBuilderFilter: (state, action) => {
            const newRow = action.payload;

            // Check if the item already exists
            const existingIndex = state.CriteriaBuilderFilter.findIndex(
                (item) =>
                    (item.fieldValue && newRow.fieldValue && item.fieldValue.toUpperCase() === newRow.fieldValue.toUpperCase()) ||
                    (item.DisplayName && newRow.DisplayName && item.DisplayName.trim().toUpperCase() === newRow.DisplayName.trim().toUpperCase())
            );

            if (existingIndex !== -1) {
                // If exists, remove it (toggle off)
                state.CriteriaBuilderFilter.splice(existingIndex, 1);
            } else {
                // If doesn't exist, add it (toggle on)
                state.CriteriaBuilderFilter.push(newRow);
            }
        },
        SetCriteriaBuilderFilterList: (state, action) => {
            state.CriteriaBuilderFilter = action.payload;
        },
        UpdateCriteriaBuilderFilter: (state, action) => {
            const { index, field, value, updates } = action.payload;

            if (!state.CriteriaBuilderFilter[index]) {
                return;
            }

            // Update multiple fields
            if (updates) {
                state.CriteriaBuilderFilter[index] = {
                    ...state.CriteriaBuilderFilter[index],
                    ...updates,
                };
                return;
            }

            // Update single field
            if (field) {
                state.CriteriaBuilderFilter[index][field] = value;
            }
        },
        ClearCriteriaBuilderFilter: (state) => {
            state.CriteriaBuilderFilter = [];
        },
        SetSelectedModule: (state, action) => {
            state.SelectedModule = action.payload;  // ChildName (Background, Balance Sheet, etc.)
        },
        SetSelectedDFMT: (state, action) => {
            state.SelectedDFMT = action.payload;    // Format type
        },
        SetSelectedScreenID: (state, action) => {
            state.SelectedScreenID = action.payload; // ScreenID
        },
        SetCompanyCodes: (state, action) => {
            state.CompanyCodes = action.payload;
        },
        SetYearEnd: (state, action) => {
            state.YearEnd = action.payload;
        },
        SetNoOfYears: (state, action) => {
            state.NoOfYears = action.payload;
        },
        ResetCriteriaState: (state) => {
            // state.CriteriaRows = [];
            state.CriteriaBuilderFilter = [];
            state.CompanyCodes = '';
            state.TotalMatchedCompanies = 0;
            state.YearEnd = 'LATEST';
            state.NoOfYears = '1';
        },
        SethandleDefaultFeilds: (state, action) => {
            state.handleDefaultFeilds = action.payload;    // Format type
        },
        setTotalMatchedCompanies : (state, action) => {
            state.TotalMatchedCompanies = action.payload;
        }


        // ============= NEW REDUCERS FOR PERSISTENCE =============
        // SetCriteriaRows: (state, action) => {
        //     state.CriteriaRows = action.payload;
        // },
        // AddCriteriaRow: (state, action) => {
        //     state.CriteriaRows.push(action.payload);
        // },
        // UpdateCriteriaRow: (state, action) => {
        //     const { index, data } = action.payload;
        //     if (state.CriteriaRows[index]) {
        //         state.CriteriaRows[index] = { ...state.CriteriaRows[index], ...data };
        //     }
        // },
        // RemoveCriteriaRow: (state, action) => {
        //     state.CriteriaRows = state.CriteriaRows.filter((_, i) => i !== action.payload);
        // },
        // ClearCriteriaRows: (state) => {
        //     state.CriteriaRows = [];
        // },

        // SetTotalMatchedCompanies: (state, action) => {
        //     state.TotalMatchedCompanies = action.payload;
        // },



        // ============= NEW: MODULE AND COLUMNS REDUCERS =============
        // SetSelectedColumns: (state, action) => {
        //     state.SelectedColumns = action.payload;  // Array of selected columns
        // },
        // ClearSelectedColumns: (state) => {
        //     state.SelectedColumns = [];
        // }

    }
})


export const {
    SetTPScreenerToken,
    SetMainModule,
    SetFilterSelection,
    SetCriteriaBuilderFilter,
    SetCriteriaBuilderFilterList,
    SethandleDefaultFeilds,
    ClearCriteriaBuilderFilter,
    UpdateCriteriaBuilderFilter,
    setTotalMatchedCompanies,
    SetCriteriaRows,
    AddCriteriaRow,
    UpdateCriteriaRow,
    RemoveCriteriaRow,
    ClearCriteriaRows,
    SetCompanyCodes,
    SetTotalMatchedCompanies,
    SetYearEnd,
    SetNoOfYears,
    ResetCriteriaState,
    // SetFilterSelection
    SetSelectedModule,
    SetSelectedDFMT,
    SetSelectedScreenID,
    SetSelectedColumns,
    ClearSelectedColumns
} = TpscreenerLocalSlice.actions

export default TpscreenerLocalSlice.reducer

